// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c9XGw","list":"styles_list__3RH3o","disableSelection":"styles_disableSelection__3mWiR"};